import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { BodyText, Button, Flex, Gutter, Logo } from '@gaiads/telia-react-component-library';
import styles from './Header.module.scss';

export default function Header() {
  const { t } = useTranslation('siteHeader');

  const checkIsMobile = () => {
    return window.innerWidth <= parseInt(styles.mobileHeaderBreakpoint, 10);
  };

  const [isMobile, setIsMobile] = useState(checkIsMobile());

  useEffect(() => {
    function handleResize() {
      setIsMobile(checkIsMobile());
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const history = useHistory();

  return (
    <>
      <Gutter size="xxs" />
      <Flex spaceBetween occupyVerticalSpace={false}>
        <Flex centeredVertically>
          <Link to={'/'}>
            <div style={{ paddingRight: '8px', borderRight: 'solid 1px #A0A0A0' }}>
              <Logo color="purple500" />
            </div>
          </Link>
          <BodyText padding={{ left: 'xs' }}>{t('customer_support_tool_name')}</BodyText>
        </Flex>
        <Button variant="primaryWhite" onClick={() => history.push('/')}>
          {isMobile ? t('closeCustomerMobile') : t('closeCustomerDesktop')}
        </Button>
      </Flex>
      <Gutter size="xxs" />
    </>
  );
}
